// react native
// @mui material components
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// @mui icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BalanceIcon from '@mui/icons-material/Balance';
import ArticleIcon from '@mui/icons-material/Article';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';

// Material Kit 2 React components
import MKBox from "../../components/MaterialKit/MKBox";
import Breadcrumbs from "../../components/Breadcrumbs";
import PricingCard from "../../components/Cards/PricingCard";
import MKTypography from "../../components/MaterialKit/MKTypography";

function CommercialLegakInsurancePage(props) {
  const unlimitedAdviceItems = [
    "Contracts",
    "Labour disputes",
    "Debtors",
    "Applicable Legislation and Regulations",
    "Licensing",
    "Litigation (civil, criminal & labour processes)"
  ];

  const contractAccessItems = [
    "Purchase and Sales Agreements",
    "Lease and Rental Agreements",
    "Service Level Agreements",
    "Customer and Supplier Agreements",
    "Loan Agreements",
    "Acknowledgement of Debt Agreements",
    "Non-disclosure Agreements",
    "Suretyships",
    "Partnership Agreements",
    "Shareholder Agreements",
    "Agency Agreements",
    "Employment Agreements"
  ];

  return (
    <>
      <MKBox
        minHeight="25vh"
        width="100%"
        variant="gradient"
        bgColor="dark"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={12}
            justifyContent="left"
            alignItems="center"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <Breadcrumbs
              routes={[
                { label: "Our Offering", route: "/" },
                { label: "Legal Cover", route: '/our-offering/legal-cover' },
                { label: "Commercial" },
              ]}
            />
          </Grid>
        </Container>
      </MKBox>

      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <MKBox component="section" pt={3} pb={8}>
          <Container>
            <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
              <Grid item xs={12} md={12} sx={{ mb: 6 }}>
                <MKTypography variant="h3" color="dark">
                  Commercial Legal Cover
                </MKTypography>
                <MKTypography variant="body2" color="dark" opacity={0.8}>
                  Applicable to SMMEs, Sole Proprietors & Entrepreneurs.
                </MKTypography>
              </Grid>
            </Grid>

            {/* Pricing Cards */}
            <Grid container spacing={0}>
              <Grid item sm={12} lg={3} md={6}>
                <PricingCard
                  amountText="Plan A"
                  amountSubText=""
                  discountTerms="Premiums quoted are risk profile dependent"
                  link="/our-offering/legal-cover/commercial-legal-cover/a/quote"
                  linkText="get a quote"
                  product={
                    {
                      name: "STANDARD",
                      components: [
                        "Limit up to R1 000 000",
                        "Up to R 2 million annual turnover",
                        "Up to 5 Employees"
                      ]
                    }
                  } />
              </Grid>
              <Grid item sm={12} lg={3} md={6}>
                <PricingCard
                  amountText="Plan B"
                  amountSubText=""
                  discountTerms="Premiums quoted are risk profile dependent"
                  link="/our-offering/legal-cover/commercial-legal-cover/b/quote"
                  linkText="get a quote"
                  product={
                    {
                      name: "COMFORT",
                      components: [
                        "Limit up to R1 000 000",
                        "Up to R 10 million annual turnover",
                        "Up to 20 Employees"
                      ]
                    }
                  } />
              </Grid>
              <Grid item sm={12} lg={3} md={6}>
                <PricingCard
                  amountText="Plan C"
                  amountSubText=""
                  discountTerms="Premiums quoted are risk profile dependent"
                  link="/our-offering/legal-cover/commercial-legal-cover/c/quote"
                  linkText="get a quote"
                  product={
                    {
                      name: "PREMIER",
                      components: [
                        "Limit up to R1 000 000",
                        "Up to R 25 million annual turnover",
                        "Up to 50 Employees"
                      ]
                    }
                  } />
              </Grid>
              <Grid item sm={12} lg={3} md={6}>
                <PricingCard
                  amountText="Plan D"
                  amountSubText=""
                  discountTerms="Premiums quoted are risk profile dependent"
                  link="/our-offering/legal-cover/commercial-legal-cover/d/quote"
                  linkText="get a quote"
                  product={
                    {
                      name: "PLATINUM",
                      components: [
                        "Limit up to R1 000 000",
                        "Up to R 50 million annual turnover",
                        "Up to 70 Employees"
                      ]
                    }
                  } />
              </Grid>
            </Grid>
            <MKBox mt={1} pt={4}>
              <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
                <Grid item xs={12} md={10} sx={{ mb: 4 }}>
                  <MKTypography variant="h4" color="dark" mb={2}>
                    Policy Advantages
                  </MKTypography>
                  <MKTypography variant="body2" color="dark" opacity={0.8}>
                    The policy advantages are, and we quote:
                  </MKTypography>
                </Grid>
              </Grid>

              <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={4}>
                  <MKBox
                    p={3}
                    borderRadius="lg"
                    sx={{
                      border: "1px solid rgba(156, 15, 24, 0.1)",
                      height: "100%"
                    }}
                  >
                    <MKBox display="flex" alignItems="center" mb={2}>
                      <BalanceIcon sx={{ color: "#9c0f18", fontSize: 28, mr: 1 }} />
                      <MKTypography variant="h5" color="dark" fontWeight="bold">
                        Unlimited Legal Advice
                      </MKTypography>
                    </MKBox>
                    {unlimitedAdviceItems.map((item, index) => (
                      <MKBox key={index} display="flex" alignItems="flex-start" mb={1}>
                        <CheckCircleIcon sx={{ color: "#9c0f18", fontSize: 18, mr: 1, mt: 0.25 }} />
                        <MKTypography variant="body2" color="dark">
                          {item}
                        </MKTypography>
                      </MKBox>
                    ))}
                  </MKBox>
                </Grid>
                <Grid item xs={12} md={4}>
                  <MKBox
                    p={3}
                    borderRadius="lg"
                    sx={{
                      border: "1px solid rgba(156, 15, 24, 0.1)",
                      height: "100%"
                    }}
                  >
                    <MKBox display="flex" alignItems="center" mb={2}>
                      <ArticleIcon sx={{ color: "#9c0f18", fontSize: 28, mr: 1 }} />
                      <MKTypography variant="h5" color="dark" fontWeight="bold">
                        Access to Contracts
                      </MKTypography>
                    </MKBox>
                    {contractAccessItems.map((item, index) => (
                      <MKBox key={index} display="flex" alignItems="flex-start" mb={1}>
                        <CheckCircleIcon sx={{ color: "#9c0f18", fontSize: 18, mr: 1, mt: 0.25 }} />
                        <MKTypography variant="body2" color="dark">
                          {item}
                        </MKTypography>
                      </MKBox>
                    ))}
                  </MKBox>
                </Grid>
                <Grid item xs={12} md={4}>
                  <MKBox
                    p={3}
                    borderRadius="lg"
                    sx={{
                      border: "1px solid rgba(156, 15, 24, 0.1)",
                      height: "100%"
                    }}
                  >
                    <MKBox display="flex" alignItems="center" mb={2}>
                      <RecordVoiceOverIcon sx={{ color: "#9c0f18", fontSize: 28, mr: 1 }} />
                      <MKTypography variant="h5" color="dark" fontWeight="bold">
                        Legal Negotiations
                      </MKTypography>
                    </MKBox>
                    <MKBox display="flex" alignItems="flex-start">
                      <CheckCircleIcon sx={{ color: "#9c0f18", fontSize: 18, mr: 1, mt: 0.25 }} />
                      <MKTypography variant="body2" color="dark">
                        This entails negotiation with third parties on your behalf in an aim to settle legal and labour disputes which you are a party to
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                </Grid>
              </Grid>
            </MKBox>
          </Container>
        </MKBox>
      </Card>
    </>
  );
}

export default CommercialLegakInsurancePage;